/**
 * L'écran provisoire d'un module.
 *
 * **Aucun écran métier n'existe encore, et le dire est le propos.** Un module
 * qui rendrait une page blanche se lirait comme une panne ; celui-ci nomme le
 * module, sa route, et l'endroit d'où viendra son contenu. C'est aussi ce qui
 * rend les seize destinations vérifiables : un test les traverse toutes et lit
 * ce que chacune affiche.
 */

import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { moduleTitleKey } from './routes.js';
import { useCurrentModule } from './useCurrentModule.js';

/** L'écran provisoire, commun aux seize modules. */
export function PlaceholderScreen(): ReactNode {
  const { t } = useTranslation();
  const module = useCurrentModule();
  if (module === undefined) return null;

  return (
    <section className="placeholder" aria-labelledby="placeholder-heading">
      <h2 className="placeholder__heading" id="placeholder-heading">
        {t('placeholder.heading')}
      </h2>
      <p className="placeholder__body">{t('placeholder.body')}</p>
      <dl className="placeholder__facts">
        <dt>{t('placeholder.moduleLabel')}</dt>
        <dd>{t(moduleTitleKey(module))}</dd>
        <dt>{t('placeholder.routeLabel')}</dt>
        <dd>
          <code>{module.path}</code>
        </dd>
      </dl>
    </section>
  );
}
